import {Component, Inject, OnInit} from '@angular/core';
import {Competitor, CompetitorSimple} from '../../../../types/competitor';
import {LoggedUser} from '../../../../types/loggedUser';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {LocalStorageService} from '../../../../../api/services/localStorage';
import {Crew, CrewSample} from '../../../../types/crew';
import {HttpHandlingService} from '../../../../../api/services/http-handling.service';
import {UntypedFormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AddCrewResponseEntity} from '../../../../types/addCrewResponseEntity';
import {LoggedCompetitor} from '../../../../types/loggedCompetitor';
import {SERVER_API_URL} from '../../../../types/app.constants';

@Component({
  selector: 'app-add-crew-card',
  templateUrl: './add-crew-card.component.html',
  styleUrls: ['./add-crew-card.component.css']
})
export class AddCrewCardComponent implements OnInit {

  loggedUser: LoggedUser;
  loggedCompetitor: LoggedCompetitor;

  crewNumber: number;
  drivers: CompetitorSimple[];
  navigators: CompetitorSimple[];
  driver: CompetitorSimple;
  navigator: CompetitorSimple;

  numbers: number[];

  crewNumberFieldControl = new UntypedFormControl('', Validators.required);
  driverFieldControl = new UntypedFormControl('', Validators.required);
  navigatorFieldControl = new UntypedFormControl('', Validators.required);

  serverIsDown = false;

  constructor(private http: HttpClient, private localStorage: LocalStorageService, private httpHandlingService: HttpHandlingService,
              @Inject(MAT_DIALOG_DATA) public data: AddCrewResponseEntity, public dialogRef: MatDialogRef<AddCrewCardComponent>) {}

  ngOnInit(): void {
    this.numbers = Array(99).fill(1).map((x, i) => 900 + i + 1).filter((crewNumber) => !this.data.crewNumbers.includes(crewNumber));
    if (this.localStorage.get('loggedUser') !== null) {
      this.loggedUser = this.localStorage.get('loggedUser') as LoggedUser;
    }
    if (this.localStorage.get('loggedCompetitor') !== null) {
      this.loggedCompetitor = this.localStorage.get('loggedCompetitor') as LoggedCompetitor;
    }
    this.drivers = this.data.availableCompetitors;
    this.navigators = this.data.availableCompetitors;
  }

  /**
   * function for filtering drivers after inserted driver
   * when user inserts driver, this driver can't be pick as navigator
   * @param selectedDriver for evaluation of selected driver
   */
  processDrivers(selectedDriver: CompetitorSimple): void {
    if ((this.driver !== undefined || null) && this.driver !== selectedDriver) {
      this.drivers.push(this.driver);
      this.navigators.push(this.driver);
    } else {
      this.driver = selectedDriver;
    }
    this.navigators = this.navigators.filter((x) => x !== selectedDriver);
  }

  /**
   * function for filtering navigators after inserted navigator
   * when user inserts navigator, this navigator can't be pick as driver
   * @param selectedNavigator for evaluation of selected navigator
   */
  processNavigators(selectedNavigator: CompetitorSimple): void {
    if ((this.navigator !== undefined || null) && this.navigator !== selectedNavigator) {
      this.navigators.push(this.navigator);
      this.drivers.push(this.navigator);
    } else {
      this.navigator = selectedNavigator;
    }
    this.drivers = this.drivers.filter((x) => x !== selectedNavigator);
  }

  /**
   * function which provides error messages in the process of updating competitor card
   * @param fieldControl with information about desired field (firstName, lastName, ...)
   */
  getErrorMessage(fieldControl: UntypedFormControl): string {
    return this.httpHandlingService.handleUserErrorOutput(fieldControl);
  }

  /**
   * function for evaluating, if all necessary fields are filled
   * this function disables button, if all data are not provided
   */
  allFieldsAreFilled(): boolean {
    return !(this.crewNumberFieldControl.valid && this.driverFieldControl.valid && this.navigatorFieldControl.valid);
  }

  /**
   * function for creating the crew with provided data
   */
  onSaveCrew(): void {
    const saveCrewURL = SERVER_API_URL + '/api/crewsWithCompetitorIds';
    const crew = new Crew(null, this.crewNumber, this.driver.id, this.navigator.id, []);
    this.http.post<any>(saveCrewURL, crew,
      {headers: this.httpHandlingService.authorizationHeaders()}).subscribe(result => {
      this.getCrewsByCompetitor(this.httpHandlingService.authorizationHeaders(), this.loggedCompetitor);
    },
      (error: HttpErrorResponse) => this.handleCreateErrors(error));
  }

  /**
   * function for receiving crews related to competitor from database and saving it into local storage
   * @param authorizationHeaders which contains information about authorization header
   * @param loggedCompetitor with information about current logged competitor and related crews
   */
  getCrewsByCompetitor(authorizationHeaders: HttpHeaders, loggedCompetitor: LoggedCompetitor): void {
    const getCrewsByCompetitorURL = SERVER_API_URL + '/api/crews-active/' + loggedCompetitor.id;
    this.http.get<CrewSample[]>(getCrewsByCompetitorURL,
      {headers: authorizationHeaders}).subscribe((crews: CrewSample[]) => {
        this.localStorage.set('loggedCompetitorCrews', crews);
      },
      (error: HttpErrorResponse) => { this.handleCreateErrors(error); },
      () => { this.dialogRef.close(); window.location.reload(); });
  }

  /**
   * function for handling HTTP errors in the process of newly added crew
   */
  handleCreateErrors(error: HttpErrorResponse): void {
    if (error.status === 0) {
      this.serverIsDown = true;
    }
  }
}
